import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store";
import axios from 'axios';
import './utils/vueFilter';
import i18n from "./plugins/i18n";
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/sass/paper-dashboard.scss";
/* import PaperDashboard from "./plugins/paperDashboard"; */
import './assets/css/GlobalVariables.scss';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import '@mdi/font/css/materialdesignicons.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueSelectImage from 'vue-select-image';
import VuePdfApp from "vue-pdf-app";
import InnerTable from "./components/InnerTable.vue";
import html2canvas from 'html2canvas';
import VueApexCharts from 'vue-apexcharts';
import './utils/directives.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import {
  parseMessage,
  notify,
  formatDate,
  normalizeString,
  sortAlphabetically,
  sortNumerically,
  sortDates,
  addQueuedJob,
} from './utils/index.js';

import { startTimer, timerDone } from "./utils/cooldownTimer.js"; // timer utilities
import VuePortal from '@linusborg/vue-simple-portal'

import Popup from "./components/Popup.vue";
import SwitchButton from "./components/SwitchButton.vue";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import TabSelector from "./components/TabSelector.vue";

Vue.component('sust-popup', Popup);
Vue.component('switch-button', SwitchButton);
Vue.component('loading-spinner', LoadingSpinner);
Vue.component('tab-selector', TabSelector);

Vue.component("vue-pdf-app", VuePdfApp);
Vue.component("inner-table", InnerTable);
Vue.component('apex-chart', VueApexCharts);
Vue.use(VueSelectImage);
Vue.use(VueToast);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApexCharts);
Vue.use(VuePortal, {name: 'portal'}); // the simples version of the 'teleport' feature from Vue3, this allows us to append popups to the body directly.

Vue.prototype.$html2canvas = html2canvas;
Vue.prototype.$startTimer = startTimer; // timer utilities 
Vue.prototype.$timerDone = timerDone; // timer utilities
Vue.prototype.$sortAlphabetically = sortAlphabetically; // table sorter utilities
Vue.prototype.$sortNumerically = sortNumerically; // table sorter utilities
Vue.prototype.$sortDates = sortDates; // table sorter utilities
Vue.prototype.$parseResMessage = parseMessage; // parsing response messages from backend
Vue.prototype.$notify = notify;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$normalizeString = normalizeString;
Vue.prototype.$addQueuedJob = addQueuedJob;

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT || '/';
axios.defaults.headers.common['Accept-Language'] = localStorage.getItem("lang");
Vue.config.productionTip = false;
Vue.config.silent = true;

if (window.opener) {
  window.opener.postMessage("app_ready", process.env.VUE_APP_CARBON_DOMAIN);
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
